import { c as _c } from "react/compiler-runtime";
import type { Actor } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useActorLabel = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "actor"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = actor => {
      if (actor.kind === "organization") {
        if (actor.firstName && actor.lastName) {
          return `${actor.firstName} ${actor.lastName}`;
        }
        return actor.email;
      }
      if (actor.kind === "firm_employee") {
        const name = [actor.firstName, actor.lastName].filter(Boolean).join(" ").trim();
        const display = name || actor.email;
        return display ? `${display} (${t(_temp)})` : t(_temp2);
      }
      if (actor.kind === "api_key") {
        return actor.name;
      }
      if (actor.kind === "footprint") {
        return t(_temp3);
      }
      return t(_temp4);
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useActorLabel;
function _temp($) {
  return $.firmEmployeeSuffix;
}
function _temp2($_0) {
  return $_0.footprint;
}
function _temp3($_1) {
  return $_1.footprint;
}
function _temp4($_2) {
  return $_2.user;
}